import React from "react"

const NoSuggestedIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="167"
      height="88"
      viewBox="0 0 167 88"
      fill="none"
    >
      <path
        d="M73.5 69C92.0015 69 107 54.0015 107 35.5C107 16.9985 92.0015 2 73.5 2C54.9985 2 40 16.9985 40 35.5C40 54.0015 54.9985 69 73.5 69Z"
        stroke="#00263A"
        strokeOpacity="0.14"
        strokeWidth="2.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.1321 61.4939C69.8908 61.8185 71.6801 61.9872 73.5 62C88.1355 62 100 50.1355 100 35.5C100 20.8645 88.1355 9 73.5 9C69.7404 9 66.1636 9.78293 62.9238 11.1946C57.2938 13.6479 52.6816 17.9999 49.896 23.4419C48.0445 27.0589 47 31.1575 47 35.5C47 39.44 47.8599 43.1792 49.4021 46.5401C50.5032 48.9396 51.9521 51.1463 53.6843 53.0956"
        fill="white"
      />
      <path
        d="M68.1321 61.4939C69.8908 61.8185 71.6801 61.9872 73.5 62C88.1355 62 100 50.1355 100 35.5C100 20.8645 88.1355 9 73.5 9C69.7404 9 66.1636 9.78293 62.9238 11.1946C57.2938 13.6479 52.6816 17.9999 49.896 23.4419C48.0445 27.0589 47 31.1575 47 35.5C47 39.44 47.8599 43.1792 49.4021 46.5401C50.5032 48.9396 51.9521 51.1463 53.6843 53.0956"
        stroke="#00263A"
        strokeOpacity="0.14"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M56.7974 56.0747C58.9455 57.8207 61.3723 59.237 64.0008 60.2466"
        stroke="#00263A"
        strokeOpacity="0.14"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M101 62L107 68"
        stroke="#00263A"
        strokeOpacity="0.14"
        strokeWidth="2.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M106.03 67.0303C104.138 68.923 104.138 71.9917 106.03 73.8844L117.116 84.9697C119.008 86.8624 122.077 86.8624 123.97 84.9697C125.863 83.077 125.863 80.0083 123.97 78.1156L112.885 67.0303C110.992 65.1375 107.923 65.1375 106.03 67.0303Z"
        stroke="#00263A"
        strokeOpacity="0.14"
        strokeWidth="2.5"
      />
      <path
        d="M111 69L122 80"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67 24C67 35.598 76.4021 45 88 45C90.2784 45 92.472 44.6372 94.5262 43.9662C91.1732 52.2871 83.0225 58.1607 73.5 58.1607C60.9849 58.1607 50.8394 48.0152 50.8394 35.5C50.8394 24.1596 59.1697 14.7648 70.045 13.1011C68.113 16.2793 67 20.0097 67 24Z"
        fill="#F5F7F7"
      />
      <path
        d="M74 17C72.7266 17 71.4825 17.1253 70.2793 17.3642M66.6447 18.4761C59.8039 21.3508 55 28.1144 55 36"
        stroke="#00263A"
        strokeOpacity="0.14"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M127.176 35.7773H119M133.5 28H116.324H133.5ZM140.5 28H138.279H140.5Z"
        stroke="#00263A"
        strokeOpacity="0.14"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.1758 57.7773H29M32.5 49H15.3242H32.5ZM9.5 49H5.27881H9.5Z"
        stroke="#00263A"
        strokeOpacity="0.14"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default NoSuggestedIcon
